module.exports = __webpack_public_path__ + "img/nequi.5db54d70.png";